import { AP_API } from './ap-api';

let installed = false;

export const ensureKeepAlive = (): void => {
  if (installed || typeof window !== 'undefined') {
    return;
  }

  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const { Agent } = require('https') as typeof import('https');

  AP_API.defaults.httpsAgent = new Agent({ keepAlive: true, maxSockets: 50 });
  installed = true;
};
